import { templateResult } from './templates'
import { isCanvasProjectType } from './project-types'
export function projectVersionStatus (value) {
  if (!value || !Number.isSafeInteger(value.revision) || value.revision < 0 || !Number.isSafeInteger(value.currentVersion) || value.currentVersion < 0 ||
    typeof value.draftVersionId !== 'string' || typeof value.publishedVersionId !== 'string' || typeof value.managed !== 'boolean' || !/^[a-f0-9]{64}$/.test(value.checksum)) throw new Error('项目版本结果无效，请重新加载')
  if (value.coverFileId != null && (typeof value.coverFileId !== 'string' || !/^[A-Za-z0-9_-]{1,64}$/.test(value.coverFileId))) throw new Error('项目封面结果无效，请重新加载')
  return { ...value }
}
export function projectDraftResult (response, id) {
  const value = templateResult(response)
  if (!value || !value.record || value.record.id !== id || !isCanvasProjectType(value.record.type)) throw new Error('大屏返回的编号或类型不一致，请重新加载')
  return { record: value.record, status: projectVersionStatus(value.status) }
}
export const revisionPayload = status => ({ revision: projectVersionStatus(status).revision, checksum: status.checksum })
// 标签只表示是否存在发布版本，草稿修改不改变发布状态或当前生效内容。
export const publicationLabel = status => status && status.publishedVersionId ? '已发布' : '未发布'
